import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { Customer } from '@df/session/api/customer';
import { IfLoggedInDirective } from '@df/session/customer/if-logged-in.directive';
import { IfNotLoggedInDirective } from '@df/session/customer/if-not-logged-in.directive';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { ModalModule } from '@df/ui/modal/modal.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ActionComponent } from '../../../ui/api/action.component';
import { LoginFormContentComponent } from '../../content/login-form-content.component';
interface ILoginFormModalData extends Catalog.IBlockData {
    modalTitle?: string;
    title: string;
    description: string;
}
export const LOGIN_FORM_MODAL_ID = 'login-form-modal';
@DfCmsModal({
    id: LOGIN_FORM_MODAL_ID,
    position: 'right',
    name: 'Login Form',
    config: (sizeId: ISizeName) => ({
        width: sizeId === 'S' ? '100vw' : '600px',
        maxWidth: StylesService.vw(100),
        height: '100%',
        minHeight: StylesService.vh(100),
        maxHeight: StylesService.vh(100),
        position: {
            top: '0',
            right: '0',
            bottom: '0'
        },
        backdropClass: sizeId === 'S' ? 'bg-col-12' : undefined,
        modalClass: 'p-a-0 bg-col-51',
        closeOnNavigation: true
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => (sizeId === 'S' ? ['S'] : ['M', 'L', 'X'])
})
@ICmsComponent<LoginFormModalComponent>({
    id: LOGIN_FORM_MODAL_ID,
    block: {
        url: LOGIN_FORM_MODAL_ID,
        autoload: 'bootstrap'
    },
    onDemandOnly: true,
    name: 'Login Form Popup',
    fields: [
        <NICmsContentField.IField>{
            key: 'modalTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Modal title',
            default: 'Wishlist'
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'description',
            type: NICmsContentField.EFieldType.text,
            title: 'Description',
            required: true
        }
    ]
})
@Component({
    selector: 'login-form-modal',
    templateUrl: './login-form-modal.html',
    styleUrls: ['login-form-modal.scss'],
    standalone: true,
    imports: [
        ActionComponent,
        ICmsClientModule,
        IfLoggedInDirective,
        IfNotLoggedInDirective,
        LoginFormContentComponent,
        ModalModule,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content: ILoginFormModalData;
    @Input()
    variant?: string;

    constructor(
        readonly customer: Customer,
        private modalRef: ModalRef<any>
    ) {
        super();
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.customer.model.obs.status.subscribe(() => this.detectChanges()));
    }

    protected close() {
        this.modalRef?.close();
    }
}
